import React from 'react';
import ImageWrapper from '../ImageWrapper';
import AniLink from 'gatsby-plugin-transition-link/AniLink';

const CourseCard = ({
    CourseName,
    CourseImage,
    CourseDescription,
    CourseUrl,
}) => {
    console.log('CourseUrl', CourseUrl);
    return (
        <>
            <AniLink
                fade
                to={`/${CourseUrl}?programtype=${convertToLowerCaseAndAddUnderscore(
                    CourseName
                )}`}
                className="course_card_item"
                style={{
                    background: `linear-gradient(180deg, rgba(41, 41, 41, 0) 0%, #292929 100%), url(${CourseImage})`,
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: 'cover',
                }}
            >
                <div className="course_card_item_first">
                    <div className="course_card_item_content">
                        <p>{CourseName}</p>
                        {/* <AniLink fade to={`/${CourseUrl}`}> */}
                        <ImageWrapper
                            ImgUrl={
                                'https://s3.us-east-2.wasabisys.com/ufaber-lms/files/b22970f6808bf5cda76cdad3377d4194.svg'
                            }
                        />
                        {/* </AniLink> */}
                    </div>
                    <p>{CourseDescription}</p>
                </div>
            </AniLink>
        </>
    );
};

function convertToLowerCaseAndAddUnderscore(inputString) {
    // Convert the string to lowercase
    let lowercaseString = inputString.toLowerCase();

    // Replace spaces with underscores
    let stringWithUnderscores = lowercaseString.replace(/\s+/g, '_');

    return stringWithUnderscores;
}
export default CourseCard;
